import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import SurplusResourcesRepair41_3bTable from "./Table";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import { ShowHide } from "../../components/ShowHideProduct";

const SurplusResourcesRepair41_3b = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("SURPLUS_RESOURCES_REPAIR") || "Surplus resources"}
        subDescription={t("SURPLUS_RESOURCES_REPAIR_41_3B_DESC") || "These include removed broken parts, damaged components, and any waste generated during repair activities. They exit the system as resources that require processing or disposal."}
        isNormal={true}
        number={"41.3b"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`surplus-resources-repair-41-3b-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <SurplusResourcesRepair41_3bTable productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default SurplusResourcesRepair41_3b;

